import request from "@/utils/axios";

export const categoryTree = (params) => {
  return request({
    url: "/api/cms/category/front/tree",
    method: "get",
    params,
  });
};
export const getNewsPage = (params, headers) => {
  return request({
    url: "/api/cms/news/front/page",
    method: "get",
    params,
    headers,
  });
};

export const getNewsDetail = (id) => {
  return request({
    url: "/api/cms/news/front/" + id,
    method: "get",
  });
};
